
import { mapGetters, mapMutations } from 'vuex'
import catalogFiltersParserQueryParams from '../../CatalogFilters/mixins/catalog-filters-parser-query-params'

export default {
  name: 'CatalogPaginationSize',
  mixins: [catalogFiltersParserQueryParams],
  data() {
    return {
      sizeList: [35, 50, 100],
    }
  },
  computed: {
    ...mapGetters({
      pageSize: 'catalog/pageSize',
    }),
  },
  methods: {
    ...mapMutations({
      setPageSize: 'catalog/SET_PAGE_SIZE',
    }),
    changeSize(pageSize) {
      if (pageSize !== this.pageSize) {
        this.setPageSize({ pageSize })
      }
    },
  },
}
